const sushiswap = require("./sushiswap");

const TOKEN_SYMBOL_TO_ADDRESS = {
  "1ETH": "0x6983d1e6def3690c4d616b13597a09e6193ea013",
  "1USDT": "0x3c2b8be99c50593081eaa2a724f0b8285f5aba8f",
  WONE: "0xcf664087a5bb0237a0bad6742852ec6c8d69a27a",
  SUSHI: "0xbec775cb42abfa4288de81f387a9b1a3c4bc552a",
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS["1ETH"]]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS["1USDT"]]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.WONE]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS["SUSHI"]]: 18
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WONE;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WONE;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  PROTOCOLS: {
    sushiswap,
  },
  NATIVE_TOKEN
};
